export default __webpack_public_path__ + "static/fog-4728764bcb8af75a99a615efde639430.jpg";